import { createFileRoute, Link } from "@tanstack/react-router";
import { MatrixAdminPanel } from "@/components/admin/MatrixAdminPanel";

export const Route = createFileRoute("/_authenticated/_admin/admin/matrix")({
  component: MatrixAdminPage,
});

function MatrixAdminPage() {
  return (
    <div style={{ padding: "2rem 1.5rem" }}>
      <div style={{ maxWidth: 880, margin: "0 auto 1.25rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 style={{ color: "var(--accent-cyan)", margin: 0 }}>Interaktionsmatrix</h1>
        <Link to="/admin" style={{ color: "var(--text-muted)", textDecoration: "none", fontSize: "0.85rem" }}>
          Zurueck zum Dashboard
        </Link>
      </div>
      <MatrixAdminPanel />
    </div>
  );
}
